<script>
import {useSettingsStore} from "@/store/settings";
import {computed} from "vue";

export default {
  name: "MainHeaderMenuNav",
  setup() {
    const settingsStore = useSettingsStore();

    const isAdmin = computed(() => {
      return settingsStore.hasAnyRole(['admin', 'superadmin']);
    });

    function scrollToFooter() {
        const footer = document.getElementById('footer-contacts');
        if (footer) {
          footer.scrollIntoView({ behavior: 'smooth' });
        }
      }
    return {scrollToFooter, isAdmin}
  }
}
</script>

<template>
  <nav class="menuNav">
    <ul class="menuNav__buttonList">
      <li class="menuNav__button">
        <a  href='#/club' class="menuNav__link">Клуб</a>
      </li>
      <li class="menuNav__button">
        <a href='#/catalog' class="menuNav__link">Магазин</a>
      </li>
<!--
      TODO: Убрать о нас, так как это то же, что и клуб

      <li class="menuNav__button">
        <a class="menuNav__link">О нас</a>
      </li>
-->
      <li class="menuNav__button">

        <a class="menuNav__link" @click="scrollToFooter">Контакты</a>
      </li>
      <li class="menuNav__button" v-if="isAdmin">
        <a href='#/admin' class="menuNav__link">Администрирование</a>
      </li>
    </ul>
  </nav>
</template>

<style lang="scss" scoped>
.menuNav {
  &__button {
    white-space: nowrap;
  }
  &__buttonList {
    display: flex;
    list-style-type: none;
    gap: 1.5rem;
    font-size: 16px;
  }
}

.menuNav__link {
  display: flex;
  height: 32px; // h-8 соответствует 2rem, если у вас база 1rem = 16px
  align-items: center;
  justify-content: center;
  padding: 0 10px; // px-2.5 соответствует 0.625rem (10px)
  color: var(--cd-text);
  font-family: var(--cd-default-font);
  font-weight: var(--cd-default-font-weight);
  font-size: 16px;
  transition: colors 0.3s; // Можно указать свою продолжительность транзишена
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: var(--cd-highlight-text);

  }
}
</style>
